
import { format } from "date-fns";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CurrencyCalculator } from "@/components/currency/CurrencyCalculator";

interface CurrencyDialogProps {
  showCurrency: boolean;
  setShowCurrency: (show: boolean) => void;
  currencyData: any;
  destinationName: string;
}

export function CurrencyDialog({
  showCurrency,
  setShowCurrency,
  currencyData,
  destinationName
}: CurrencyDialogProps) {
  return (
    <Dialog open={showCurrency} onOpenChange={setShowCurrency}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            Currency Exchange for {destinationName}
          </DialogTitle>
          <DialogDescription>
            Calculate currency conversions for your trip
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          {currencyData ? (
            <CurrencyCalculator 
              sourceCurrency={currencyData.sourceCurrency} 
              targetCurrency={currencyData.targetCurrency} 
              exchangeRate={currencyData.exchangeRate} 
            />
          ) : (
            <div className="text-center py-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-travel-500 mx-auto"></div>
              <p className="mt-2 text-sm text-muted-foreground">Loading currency data...</p>
            </div>
          )}
        </div>
        {currencyData && (
          <DialogFooter className="flex flex-col items-start sm:flex-row sm:justify-between sm:items-center">
            <p className="text-xs text-muted-foreground">
              Last updated: {currencyData.lastUpdated ? 
                format(new Date(currencyData.lastUpdated), "MMM d, yyyy HH:mm") : 
                "Unknown"}
            </p>
            <Button variant="outline" size="sm" onClick={() => setShowCurrency(false)}>
              Close
            </Button>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
}
